let biteBeep = (): void => {};

if (typeof AudioContext !== 'undefined') {
  const audio = new AudioContext(); // browsers limit the number of concurrent audio contexts, so you better re-use'em
  biteBeep = (): void => {
    const vol = 1;
    const freq = 220;
    const duration = 100;

    const oscillator = audio.createOscillator();
    const gainNode = audio.createGain();
    oscillator.connect(gainNode);
    oscillator.frequency.value = freq;
    oscillator.type = 'square';
    gainNode.connect(audio.destination);
    gainNode.gain.value = vol * 0.01;
    oscillator.start(audio.currentTime);
    oscillator.stop(audio.currentTime + duration * 0.001);
  };
}

export { biteBeep };

if (['dev', 'test'].includes(window.env)) {
  window.onerror = (event, source, lineno, colno) => {
    // oxlint-disable-next-line no-console
    console.error('UNCAUGHT ERROR', event, source, lineno, colno);
    biteBeep();
  };
}
